import { typography } from "../../../design/tokens";
import { BuildPlatform } from "../../../core_stores/useProjectBuildsStore";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";

export default function ProjectPublishAvailablePlatforms({
  allPlatforms,
  selectedPlatform,
  onPlatformSelected,
}: {
  allPlatforms: {
    type: BuildPlatform;
    label: string;
    icon: React.ReactNode;
    enabled: boolean;
  }[];
  selectedPlatform: BuildPlatform | null;
  onPlatformSelected: (platformType: BuildPlatform) => void;
}) {
  const isCompactView = useIsCompactView();

  return (
    <div className="grid grid-cols-3 gap-4">
      {allPlatforms.map((platform) => (
        <div key={platform.type} className="relative">
          <button
            onClick={() =>
              platform.enabled && onPlatformSelected(platform.type)
            }
            disabled={!platform.enabled}
            className={`w-full h-24 flex flex-col items-center
                  justify-center gap-2 p-3 rounded-xl
                  disabled:opacity-100
                  border border-dark-border
                  ${
                    selectedPlatform === platform.type
                      ? "bg-dark-surface-secondary"
                      : "bg-dark-surface-primary text-dark-text"
                  } ${
              !platform.enabled
                ? "opacity-100 cursor-not-allowed"
                : !isCompactView
                  ? "hover:cursor-pointer hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 group"
                  : "transition-all duration-300"
            }`}
          >
            {/* Colorful gradient glow on hover only for enabled platforms (desktop) */}
            {platform.enabled && !isCompactView && (
              <div
                className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{
                  boxShadow: '0 0 20px rgba(233, 30, 99, 0.5), 0 0 40px rgba(156, 39, 176, 0.4)',
                }}
              />
            )}

            <div className="relative z-10 flex flex-col items-center gap-2">
              {platform.icon}
              <span className={`${typography.size.sm} font-medium`}>{platform.label}</span>
            </div>
          </button>
          {!platform.enabled && (
            <div
              className="absolute -top-2 -right-2 text-xs px-2 py-1 rounded-full
                bg-dark-surface-primary text-dark-text"
            >
              Soon
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
